// Versione del frontend PWA. Da BUMPARE a ogni modifica sostanziale: compare nel menu
// hamburger dell'app agente, cosi' si verifica a colpo d'occhio che il dispositivo abbia
// preso l'aggiornamento (se il numero cambia, la build nuova e' arrivata).
export const APP_VERSION = '24.2';
